import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import geoGroupRoutes from '../../../routes/geoGroupRoutes';

const readAll = createAsyncThunk(
  'thunk/geoGroup/readAll',
  async (arg, thunkAPI) => {
    const response = await apiFetch(geoGroupRoutes.api.readAll, {
      body: arg?.data,
    });
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default readAll;
